import {post} from "@/http/request";

/**
 * 获取每日图片
 * @param data
 * @returns {*}
 */
export const reqGetDailyPhoto = data => post('/ocean-bing/photo/getDailyPhoto', data);
